import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "../../common/api/http.service";
import { ExportApi } from "./export.api";

@Injectable()
export class FranchiseApi {
  private readonly apiController: string = "franchise";

  constructor(private api: HttpService, private exportApi: ExportApi) {}

  isFranchisor(franchiseCode: string): Observable<boolean> {
    return this.api.get(`${this.apiController}/${franchiseCode}/is-franchisor`);
  }

  getResellers(franchiseCode: string): Observable<any[]> {
    return this.api.get(`${this.apiController}/${franchiseCode}/resellers`);
  }

  get(franchiseName: string): Observable<any> {
    return this.api.get(`${this.apiController}/${franchiseName}`);
  }

  calculateRevenueForReseller(resellerId: number): Observable<any> {
    return this.api.get(`${this.apiController}/revenue/reseller/${resellerId}`);
  }

  calculateRevenuePerReseller(
    periodStart: Date,
    periodEnd: Date
  ): Observable<any> {
    return this.api.get(
      `${
        this.apiController
      }/revenue/reseller?periodStart=${periodStart.toDateString()}&periodEnd=${periodEnd.toDateString()}`
    );
  }

  topResellersByRevenue(periodStart: Date, periodEnd: Date): Observable<any> {
    return this.api.get(
      `${
        this.apiController
      }/revenue/reseller/top?periodStart=${periodStart.toDateString()}&periodEnd=${periodEnd.toDateString()}`
    );
  }

  topResellersByClientCount(
    periodStart: Date,
    periodEnd: Date
  ): Observable<any> {
    return this.api.get(
      `${
        this.apiController
      }/clients/reseller/top?periodStart=${periodStart.toDateString()}&periodEnd=${periodEnd.toDateString()}`
    );
  }

  countClients(): Observable<any> {
    return this.api.get(`${this.apiController}/clients/count`);
  }

  countResellers(): Observable<any> {
    return this.api.get(`${this.apiController}/resellers/count`);
  }

  calculateRevenuePerMonth(): Observable<any> {
    return this.api.get(`${this.apiController}/revenue/monthly`);
  }

  calculateUnRealisedRevenue(): Observable<number> {
    return this.api.get(`${this.apiController}/revenue/unrealised`);
  }

  exportRevenuePerReseller(
    periodStart: Date,
    periodEnd: Date
  ): Observable<any> {
    return this.exportApi.get(
      `${
        this.apiController
      }/revenue/reseller/export?periodStart=${periodStart.toDateString()}&periodEnd=${periodEnd.toDateString()}`
    );
  }
}
